import "./Phone.scss";
import { useTranslation } from "react-i18next";
import { FormProps } from "Utilities/Types";
import Error from "Components/InputsForm/Error";

const Phone: React.FC<FormProps> = ({
  register,
  errors,
  watch,
  placeholder,
}) => {
  const { t } = useTranslation();

  const pattern = {
    value: /^[0-9+]+$/,
    message: "patternPhone",
  };
  const minLength = {
    value: 8,
    message: "minLengthPhone",
  };
  return (
    <div className="form_box phone">
      <label htmlFor="phone">{t("contact.form.phone")}</label>
      <input
        type="text"
        autoComplete="tel"
        className={
          errors.phone ? "input input-focus invalid" : "input input-focus"
        }
        id="phone"
        {...register("phone", {
          pattern,
          minLength,
        })}
        placeholder={placeholder}
      />
      <Error error={errors.phone || errors.phoneCode} />
    </div>
  );
};

export default Phone;
